/**
 * Created by renatolovizotto on 13/07/17.
 */
import {action, observable} from "mobx";
import api from '../utils/api';


class StudentStore {

    @observable isLoading = false;
    @observable students = [];

    @action
    async getStudents(params) {

        this.isLoading = true;

        return await api.call(`/students/class/${params['id_sf_teacher']}`, "GET", params)
            .then(
                response => {
                    this.isLoading = false;

                    if (response instanceof Response) {
                        return null;
                    }

                    this.students = this._orderByName(response);
                }
            )
    }

    _orderByName(students) {
        return students.sort((a, b) => {
            return a.firstname.localeCompare(b.firstname);
        });
    }
}

export default new StudentStore();


// WEBPACK FOOTER //
// ./src/stores/StudentStore.js